export class Family {
  familyId : number;
  schoolName : string;
  completedName : string;
  bankAccount : string;
  accountingAccount : string;
  phone : string;
  mobilePhone : string;
  email: string;
  yearDebtDescription : string;
  manager : string;
  zoneId : number;
  zoneName : string;
  dni : string;
  active: boolean;
  exerciseId: number;
}
